import { IObject } from './defaultTypes';

export default (obj: IObject, toDelete: string[] | undefined) => {
  const newObj = obj && { ...obj };
  if (newObj && toDelete) {
    toDelete.forEach(attrName => {
      delete newObj[attrName];
    });
  }

  return newObj;
};
